import { useEffect } from "react";
import { arrayOf, bool, func, shape, string } from "prop-types";

import { routes } from "../../constants";

import { Link } from "react-router-dom";

const ContactLocations = ({
  className,
  locations,
  locationsError,
  locationsFetch,
  locationsLoading,
}) => {
  useEffect(() => {
    if (
      (!locations || !locations.length) &&
      !locationsError &&
      !locationsLoading
    ) {
      locationsFetch();
    }
  }, [locations, locationsError, locationsFetch, locationsLoading]);

  return !locations || !locations.length ? null : (
    <ul className={className}>
      {locations.map(({ locationCity, slug }) => (
        <li key={slug}>
          <Link to={`${routes.location.path}/${slug}`}>{locationCity}</Link>
        </li>
      ))}
    </ul>
  );
};

ContactLocations.propTypes = {
  className: string,
  locations: arrayOf(
    shape({
      locationCity: string,
      slug: string,
    })
  ),
  locationsError: string,
  locationsFetch: func.isRequired,
  locationsLoading: bool,
};

export default ContactLocations;
